import type { HTMLAttributes } from 'react';
import type React from 'react';

import { Separator, Text } from '@change/ds-core-ui';

import { EmbeddedMedia } from '#src/app/shared/components/embeddedMedia';
import { Html } from '#src/app/shared/components/html';

import { Actions } from './components/Actions';
import { ShareLinks } from './components/ShareLinks';
import { StarterActions } from './components/StarterActions';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
	const {
		data: { description, creationDate, embeddedMedia },
	} = usePageBody();

	return (
		<div className="mt-8 px-4 sm:px-2" {...props}>
			<div>
				<Text variant="body" fontWeight="normal">
					{creationDate}
				</Text>
			</div>

			{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
			<div className="mt-2 mb-6 md:mb-[52px]" data-qa="dm-response-description">
				<Text variant="body" as="span" fontWeight="normal" size="medium" expressive>
					<Html as="span" noContentStyles html={description} />
				</Text>
			</div>
			{embeddedMedia?.html && (
				<EmbeddedMedia
					html={embeddedMedia.html}
					aspectRatio={embeddedMedia.aspectRatio || undefined}
					className="mt-4 [&>iframe]:w-full md:[&>iframe]:w-[600px]"
					data-qa="embedded-media"
				/>
			)}
			<Actions />
			{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
			<Separator orientation="horizontal" className="mt-6 mb-6 md:mt-[52px]" />
			<ShareLinks />
			<StarterActions />
		</div>
	);
};
